import React from 'react';
import { Box, Grid } from '@mui/material';
import LeaveSettingPage from './LeaveSettingPage';


const LeaveSettingsHome = () => {
    return (
        <Box sx={{ backgroundColor: 'background.main', border: "1px solid #1e2734" }} className="h-full overflow-hidden ">
            <div className="h-full" style={{ overflowY: 'auto', paddingRight: '1px' }}>
                <Box className="p-2  md:p-5">
                    <Grid item xs={11}>
                       <LeaveSettingPage/>
                    </Grid>
                </Box>
            </div>
            <style jsx>{`
                
                .h-full::-webkit-scrollbar {
                    display: none;
                }
                .h-full {
                    scrollbar-width: none;
                }
            `}</style>

        </Box>
    );
};

export default LeaveSettingsHome;
